import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrls: ['./cookies.component.scss'],
    standalone: false
})
export class CookiesComponent implements OnInit {

  mostrarAvisoCookies : boolean = false;
  constructor() { }

  estouCiente(){
    localStorage.setItem('estouCiente', 'true');
    this.mostrarAvisoCookies = true;
  }

  ngOnInit(): void {
    this.mostrarAvisoCookies = localStorage.getItem('estouCiente') == 'true';
  }

}
